import React, { useMemo, useState } from "react";
import { Card, Icon, Title, Tooltip } from "@skyportal/ui-kit";
import BucketSizeChart from "./BucketSizeChart";
import { bucketSizeMock } from "./mocks";
import { filterByRange, mapToChartData } from "./utils";
import { DateButtons } from "components/DateButtons";
import { DATE_OPTIONS } from "./constants";

import styles from "./BucketSizeChartCard.module.css";

const BucketSizeChartCard: React.FC = () => {
  const [selected, setSelected] = useState("3M");

  const chartData = useMemo(() => {
    return mapToChartData(filterByRange(bucketSizeMock, selected));
  }, [selected]);

  return (
    <Card
      className={styles.card}
      title={
        <div className={styles.titleContainer}>
          <Title level={5}>Bucket size</Title>

          <Tooltip title="Test tooltip for bucket size">
            <div className={styles.tooltipIcon}>
              <Icon icon="info" height={16} color="black" />
            </div>
          </Tooltip>
        </div>
      }
      controls={
        <div className={styles.headerControls}>
          <DateButtons dates={DATE_OPTIONS} selected={selected} onBtnClick={setSelected} />
        </div>
      }
    >
      <div className={styles.content}>
        <BucketSizeChart data={chartData} />
      </div>
    </Card>
  );
};

export default BucketSizeChartCard;
